import { render, staticRenderFns } from "./in-table-user.vue?vue&type=template&id=12589430"
import script from "./in-table-user.vue?vue&type=script&lang=js"
export * from "./in-table-user.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports